import { HttpError } from 'utils/HttpError';

import { handleErrors } from './handleErrors';

export function postData(url: string, formData: FormData) {
  const retriesRemaining = 1;
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.addEventListener('load', () => {
      handleErrors(
        xhr.status,
        url,
        () => resolve(xhr.responseText),
        () => reject(new HttpError('GET', url, xhr)),
        {
          retriesRemaining,
        },
      );
    });
    xhr.open('POST', url, true);
    xhr.send(formData);
  });
}
